import {
  getTranslatedText,
  useProduct,
  COMMON_CONSTANTS,
  useActivityTracker,
  AccessControl
} from '@nile/components';
import { Modal, DisplayText } from '@superops/ui-design-system';
import React from 'react';
import { injectIntl } from 'react-intl';
import QRCode from 'react-qr-code';

function QRCodeModal(props) {
  const {
    id,
    intl,
    clientName,
    siteName,
    type,
    showQRActive,
    closeQRModal,
    name,
    displayId,
    classId
  } = props;
  const productType = useProduct();
  const typeMap = {
    ticket: {
      header: getTranslatedText(intl, 'common.show.ticket.qr.modal.title'),
      value: 'ticket',
      qrValue: `https://${window.location.host}/#/tickets/${id}/ticket`
    },
    asset: {
      header: getTranslatedText(intl, 'common.show.asset.qr.modal.title'),
      value: 'asset',
      qrValue: `https://${window.location.host}/#/rmm/details/asset/${id}`
    },
    unmonitoredAsset: {
      header: getTranslatedText(intl, 'common.show.asset.qr.modal.title'),
      value: 'asset',
      qrValue: `https://${window.location.host}/#/rmm/details/asset/${id}/${classId}`
    },
    networkAsset: {
      header: getTranslatedText(intl, 'common.show.asset.qr.modal.title'),
      value: 'asset',
      qrValue: `https://${window.location.host}/#/rmm/details/asset/${id}`
    }
  };
  const QRValue = typeMap[type]?.qrValue;

  const downloadQR = () => {
    useActivityTracker({
      event: `QR Code print - Action for ${type}`
    });

    const content = document.getElementById('contentToPrint');

    const printWindow = window.open(
      '',
      '',
      `width=${window.screen.width},height=${window.screen.height}`
    );
    printWindow.document.write(
      `<html>
        <head>
          <title>SuperOps QR print</title>
          </head>
          <body>
            <div style ="display: flex; flex-wrap: wrap; height: 120px; align-items: flex-start;">
                <div style ="margin-right: 10px;">
                ${content.innerHTML}
                </div>
                ${
                  productType == COMMON_CONSTANTS.MSP
                    ? `   <div style ="display: flex; flex-direction: column;">
                    <div style="margin-bottom: 10px;">
                      ${
                        typeMap[type]?.value === 'asset'
                          ? name
                          : `#${displayId}`
                      }
                    </div>  
                     <div>
                          ${getTranslatedText(
                            intl,
                            'common.client'
                          )}: ${clientName}
                      </div>
                    <div>
                     ${getTranslatedText(intl, 'common.site')}: ${siteName}
                    </div>
                </div>`
                    : ''
                }
             
            </div>
          </body>
        </html>
        `
    );

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  return (
    <Modal
      open={showQRActive}
      onClose={closeQRModal}
      title={typeMap[type]['header'] || ''}
      primaryAction={{
        content: getTranslatedText(intl, 'common.print'),
        onAction: downloadQR
      }}
    >
      <Modal.Section>
        <div
          className={
            productType === COMMON_CONSTANTS.IT ? 'fx jctr' : 'fx astart'
          }
        >
          <div className="w20 ignoreOverride" id="contentToPrint">
            <QRCode
              value={QRValue}
              style={{ height: '100px', width: '100px' }}
            />
          </div>
          <AccessControl
            productToCheck={COMMON_CONSTANTS.MSP}
            render={
              <div className="w-80 pl5 ml-15">
                <DisplayText element="h2" weight="Bold">
                  {typeMap[type]?.value === 'asset' ? name : `#${displayId}`}
                </DisplayText>
                <div className="jspbtwn mt20">
                  <div className="fx">
                    <DisplayText size="small" element="h3" weight="Regular">
                      {getTranslatedText(intl, 'common.client')}:
                    </DisplayText>
                    <div className="ml-5">
                      <DisplayText size="small" element="h3" weight="Regular">
                        {clientName}
                      </DisplayText>
                    </div>
                  </div>

                  <div className="fx mt10">
                    <DisplayText size="small" element="h3" weight="Regular">
                      {getTranslatedText(intl, 'common.site')}:
                    </DisplayText>
                    <div className="ml-5">
                      <DisplayText size="small" element="h3" weight="Regular">
                        {siteName}
                      </DisplayText>
                    </div>
                  </div>
                </div>
              </div>
            }
          />
        </div>
      </Modal.Section>
    </Modal>
  );
}

export default injectIntl(QRCodeModal);
